
import { printf, toFail, concat, interpolate } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { getTextWidthInPixels, Text$, defaultText } from "../Common/DrawHelpers.js";
import { $007CIsBinaryGate$007CNotBinaryGate$007C, isClockedGiven, clockedSheets, SymbolInfo, PortType, STransform, Component as Component_2, Port, Rotation, Edge, BoundingBox, XYPos } from "../Common/CommonTypes.js";
import { contains, findIndex, length, exists, zip, fold, filter, append, max, isEmpty, map as map_1, collect, empty, reverse, singleton, removeAt, item, ofArray } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { safeHash, compare, comparePrimitives, int32ToString, Exception, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { DrawModelType_SymbolT_AppearanceT, DrawModelType_SymbolT_ShowCorners, DrawModelType_SymbolT_ShowPorts, DrawModelType_SymbolT_Symbol, DrawModelType_SymbolT_PortMaps, DrawModelType_SymbolT_Annotation } from "../Model/DrawModelType.js";
import { filter as filter_1, toList as toList_1, ofList, tryFind, fold as fold_2, keys, empty as empty_1, remove, add, FSharpMap__get_Item, find, map } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { isDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { toList, last } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { IdAllocator_newComponentId, memoizeByIdentity, IdAllocator_newPortId } from "../Common/Helpers.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { fold as fold_1, FSharpSet_op_Subtraction, ofSeq } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { max as max_1 } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { warn } from "../Shared/Log.js";

export const Constants_mergeSplitTextSize = "10px";

export const Constants_busSelectTextSize = "12px";

export const Constants_customPortSpacing = 40;

export const Constants_portPosEdgeGap = 0.7;

export const Constants_gatePortPosEdgeGap = 0.3;

export const Constants_legendVertOffset = 5;

export const Constants_legendLineSpacingInPixels = 16;

export const Constants_testShowLabelBoundingBoxes = false;

export const Constants_portFontSizeInPixels = 12;

export const Constants_labelFontSizeInPixels = 16;

export const Constants_customLegendFontSizeInPixels = 16;

export const Constants_otherLegendFontSizeInPixels = 14;

export const Constants_arrayLegendFontSizeInPixels = 11;

export const Constants_bitIndicationFontWeight = "400";

export const Constants_componentLabelStyle = new Text$("start", `${interpolate("%.0f%P()", [Constants_labelFontSizeInPixels])}px`, "500", "Verdana", defaultText.Fill, defaultText.UserSelect, defaultText.DominantBaseline);

export const Constants_componentPortStyle = new Text$("start", `${interpolate("%.0f%P()", [Constants_portFontSizeInPixels])}px`, "500", "Verdana", defaultText.Fill, defaultText.UserSelect, defaultText.DominantBaseline);

export const Constants_componentLabelOffsetDistance = Constants_testShowLabelBoundingBoxes ? 0 : 7;

export const Constants_thinComponentLabelOffsetDistance = Constants_testShowLabelBoundingBoxes ? 0 : 3;

export const Constants_componentLabelHeight = Constants_labelFontSizeInPixels;

export const Constants_labelCorrection = new XYPos(0, 0);

export const Constants_customComponentHint = ofArray(["Right-click to move its", "ports or resize it"]);

export function DrawModelType_SymbolT_Symbol__Symbol_get_SymbolBoundingBox(this$) {
    let left, right;
    const sym = this$;
    let patternInput;
    const sym_1 = sym;
    const comp = sym_1.Component;
    const matchValue = defaultArg(sym_1.HScale, 1);
    const vS = defaultArg(sym_1.VScale, 1);
    const hS = matchValue;
    const matchValue_2 = sym_1.STransform.Rotation;
    switch (matchValue_2.tag) {
        case 1:
        case 3: {
            patternInput = [comp.W * hS, comp.H * vS];
            break;
        }
        default:
            patternInput = [comp.H * vS, comp.W * hS];
    }
    if (equals(sym.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton)) {
        return new BoundingBox((left = sym.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17);
    }
    else {
        return new BoundingBox(sym.Pos, patternInput[1], patternInput[0]);
    }
}

/**
 * Returns all the bounding boxes of all components in the model
 */
export function getBoundingBoxes(symModel) {
    return map((sId, sym) => {
        let left, right;
        const sym_1 = sym;
        let patternInput;
        const sym_2 = sym_1;
        const comp = sym_2.Component;
        const matchValue = defaultArg(sym_2.HScale, 1);
        const vS = defaultArg(sym_2.VScale, 1);
        const hS = matchValue;
        const matchValue_2 = sym_2.STransform.Rotation;
        switch (matchValue_2.tag) {
            case 1:
            case 3: {
                patternInput = [comp.W * hS, comp.H * vS];
                break;
            }
            default:
                patternInput = [comp.H * vS, comp.W * hS];
        }
        return equals(sym_1.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton) ? (new BoundingBox((left = sym_1.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17)) : (new BoundingBox(sym_1.Pos, patternInput[1], patternInput[0]));
    }, symModel.Symbols);
}

/**
 * Returns the bounding boxes of all symbol labels in the model
 */
export function getLabelBoundingBoxes(model) {
    return map((_arg, sym) => sym.LabelBoundingBox, model.Symbols);
}

/**
 * Returns the bounding box of the symbol associated with compId
 */
export function getLabelBoundingBox(model, compId) {
    return find(compId, model.Symbols).LabelBoundingBox;
}

/**
 * Returns color for the fill of a symbol (when not selected)
 * Depends on theme and whether symbol is closed or not.
 */
export function getSymbolColour(compType, clocked, theme) {
    switch (theme.tag) {
        case 2: {
            let matchResult;
            switch (compType.tag) {
                case 33:
                case 34:
                case 40:
                case 31:
                case 32:
                case 41:
                case 42:
                case 35:
                case 37:
                case 36:
                case 38: {
                    matchResult = 0;
                    break;
                }
                case 48:
                case 0:
                case 1:
                case 2:
                case 49:
                case 7: {
                    matchResult = 2;
                    break;
                }
                case 50:
                case 51:
                case 52:
                case 53: {
                    matchResult = 3;
                    break;
                }
                case 28:
                case 27:
                case 4: {
                    matchResult = 4;
                    break;
                }
                case 29:
                case 30: {
                    matchResult = 5;
                    break;
                }
                case 26: {
                    if (clocked) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 6;
                    }
                    break;
                }
                default:
                    matchResult = 6;
            }
            switch (matchResult) {
                case 0:
                    return "lightblue";
                case 1:
                    return "lightblue";
                case 2:
                    return "#E8D0A9";
                case 3:
                    return "#DCCAE8";
                case 4:
                    return "rgb(120,120,120)";
                case 5:
                    return "lightgray";
                default:
                    return "rgba(255,255,217,1)";
            }
        }
        default:
            return "lightgray";
    }
}

/**
 * Modify port position maps to move an existing Lefthand port (index in the list) to the bottom edge
 */
export function movePortToBottom(portMaps, index) {
    const portId = item(index, FSharpMap__get_Item(portMaps.Order, Edge.Left));
    return new DrawModelType_SymbolT_PortMaps(add(Edge.Left, removeAt(index, FSharpMap__get_Item(portMaps.Order, Edge.Left)), add(Edge.Bottom, singleton(portId), portMaps.Order)), add(portId, Edge.Bottom, portMaps.Orientation));
}

/**
 * Work out a label bounding box from symbol, return symbol with box added.
 * The box has a margin Constants. componentLabelOffsetDistance around the label text outline.
 * This function should be included at the end of any function that changes component
 * or label position or orientation or shape.
 */
export function calcLabelBoundingBox(sym) {
    const transform = sym.STransform;
    const comp = sym.Component;
    let labelRotation;
    let r_1;
    if (transform.flipped) {
        const matchValue_1 = transform.Rotation;
        r_1 = ((matchValue_1.tag === 1) ? Rotation.Degree270 : ((matchValue_1.tag === 3) ? Rotation.Degree90 : transform.Rotation));
    }
    else {
        r_1 = transform.Rotation;
    }
    const r1 = defaultArg(sym.LabelRotation, Rotation.Degree0);
    const r2 = r_1;
    const rot90 = (rot) => {
        switch (rot.tag) {
            case 1:
                return Rotation.Degree180;
            case 2:
                return Rotation.Degree270;
            case 3:
                return Rotation.Degree0;
            default:
                return Rotation.Degree90;
        }
    };
    const rot180 = (rot_1) => {
        switch (rot_1.tag) {
            case 1:
                return Rotation.Degree270;
            case 2:
                return Rotation.Degree0;
            case 3:
                return Rotation.Degree90;
            default:
                return Rotation.Degree180;
        }
    };
    labelRotation = ((r1.tag === 1) ? rot90(r2) : ((r1.tag === 2) ? rot180(r2) : ((r1.tag === 3) ? rot180(rot90(r2)) : r2)));
    let patternInput_1;
    const sym_1 = sym;
    const comp_1 = sym_1.Component;
    const matchValue_2 = defaultArg(sym_1.HScale, 1);
    const vS = defaultArg(sym_1.VScale, 1);
    const hS = matchValue_2;
    const matchValue_2_1 = sym_1.STransform.Rotation;
    switch (matchValue_2_1.tag) {
        case 1:
        case 3: {
            patternInput_1 = [comp_1.W * hS, comp_1.H * vS];
            break;
        }
        default:
            patternInput_1 = [comp_1.H * vS, comp_1.W * hS];
    }
    let centre;
    const symbol = sym;
    const comp_2 = symbol.Component;
    let patternInput_2;
    const comp_3 = comp_2;
    const matchValue_3 = defaultArg(symbol.HScale, 1);
    const vS_1 = defaultArg(symbol.VScale, 1);
    const hS_1 = matchValue_3;
    const matchValue_2_2 = symbol.STransform.Rotation;
    switch (matchValue_2_2.tag) {
        case 1:
        case 3: {
            patternInput_2 = [comp_3.W * hS_1, comp_3.H * vS_1];
            break;
        }
        default:
            patternInput_2 = [comp_3.H * vS_1, comp_3.W * hS_1];
    }
    centre = (new XYPos(comp_2.X + (patternInput_2[1] / 2), comp_2.Y + (patternInput_2[0] / 2)));
    let margin;
    const matchValue_4 = sym.Component.Type;
    switch (matchValue_4.tag) {
        case 3:
        case 6:
        case 4: {
            margin = Constants_thinComponentLabelOffsetDistance;
            break;
        }
        default:
            margin = Constants_componentLabelOffsetDistance;
    }
    const labH = Constants_componentLabelHeight;
    const labW = getTextWidthInPixels(Constants_componentLabelStyle, comp.Label);
    const boxTopLeft = (labelRotation.tag === 3) ? (new XYPos(comp.X + patternInput_1[1], (centre.Y - (labH / 2)) - margin)) : ((labelRotation.tag === 1) ? (new XYPos((comp.X - (2 * margin)) - labW, (centre.Y - (labH / 2)) - margin)) : ((labelRotation.tag === 2) ? (new XYPos((centre.X - (labW / 2)) - margin, comp.Y + patternInput_1[0])) : (new XYPos((centre.X - (labW / 2)) - margin, (comp.Y - labH) - (2 * margin)))));
    return new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, (comp.Label === "") ? (new BoundingBox(boxTopLeft, 0, 0)) : (sym.LabelHasDefaultPos ? (new BoundingBox(boxTopLeft, labW + (2 * margin), labH + (2 * margin))) : sym.LabelBoundingBox), sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, sym.Component, sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText);
}

/**
 * Insert titles compatible with greater than 1 buswidth
 */
export function busTitleAndBits(t, n) {
    if (n === 1) {
        return t;
    }
    else if ((t === "") && (n > 1)) {
        return `${t}(${n - 1}:${0})`;
    }
    else if (n > 1) {
        return `${t}.(${n - 1}:${0})`;
    }
    else {
        throw new Exception("non positive bus width");
    }
}

/**
 * The legend of an array component's IO: what the copies do with the value, and its width.
 * 
 * One line, unlike busTitleAndBits, which puts the width on a second line by way of a "." that
 * addLegendText splits on. Two lines were what stopped these resizing with their width - the
 * symbol is sized by its widest LINE, which was always the first, so the bit range never reached
 * it - and there is room for one line because the symbol is as long as it needs to be.
 */
export function arrayLegend(t, n) {
    if (n <= 1) {
        return t;
    }
    else {
        return `${t} (${n - 1}:0)`;
    }
}

export const arrayLegendStyle = (() => {
    const bind$0040 = Constants_componentLabelStyle;
    return new Text$(bind$0040.TextAnchor, `${interpolate("%.0f%P()", [Constants_arrayLegendFontSizeInPixels])}px`, "normal", bind$0040.FontFamily, bind$0040.Fill, bind$0040.UserSelect, bind$0040.DominantBaseline);
})();

export const widestExpectedJoinLegend = arrayLegend("Join[3]", 16);

export function nBitsGateTitle(gateType, n) {
    if (n === 1) {
        return gateType;
    }
    else {
        return ((int32ToString(n) + "-bit.") + gateType) + "-N";
    }
}

/**
 * Insert titles for bus select
 */
export function busSelectTitle(wob, lsb) {
    if (wob === 1) {
        return `(${lsb})`;
    }
    else if (wob > 1) {
        return `(${(wob + lsb) - 1}:${lsb})`;
    }
    else {
        throw new Exception("non positive bus width in bustitle");
    }
}

/**
 * Decodes the component type into component labels
 */
export function getPrefix(compType) {
    switch (compType.tag) {
        case 8:
        case 10:
            return "G";
        case 11:
            return "MUX";
        case 12:
            return "MUX";
        case 13:
            return "MUX";
        case 14:
            return "DM";
        case 15:
            return "DM";
        case 16:
            return "DM";
        case 46:
            return "SHIFT";
        case 17:
        case 18:
        case 19:
        case 20:
            return "ADD";
        case 21:
            return "NXOR";
        case 22:
            return "AND";
        case 24:
            return "OR";
        case 23:
            return "NOT";
        case 25:
            return "S";
        case 31:
        case 32:
            return "FF";
        case 33:
        case 34:
            return "REG";
        case 39:
            return "AROM";
        case 40:
            return "ROM";
        case 41:
            return "RAM";
        case 42:
            return "ARAM";
        case 26: {
            const c = compType.fields[0];
            return c.Name.toLocaleUpperCase() + (isDigit(last(c.Name.split(""))) ? "." : "");
        }
        case 7:
            return "C";
        case 47:
        case 5:
            return "EQ";
        case 9:
            return "DEC";
        case 35:
        case 37:
        case 36:
        case 38:
            return "CNT";
        case 27:
            return "MW";
        case 29:
            return "MN";
        case 28:
            return "SW";
        case 30:
            return "SN";
        case 50:
            return "BO";
        case 51:
            return "MO";
        case 52:
            return "JO";
        case 53:
            return "JI";
        default:
            return "";
    }
}

export function getGateComponentLegend(gType) {
    switch (gType) {
        case "or":
        case "nor":
            return "≥1";
        case "xor":
        case "xnor":
            return "=1";
        default:
            return "&";
    }
}

export function getTextGateComponentLegend(gType) {
    switch (gType) {
        case "or":
            return "Or";
        case "xor":
            return "Xor";
        case "nand":
            return "Nand";
        case "nor":
            return "Nor";
        case "xnor":
            return "Xnor";
        default:
            return "And";
    }
}

export function getGateNComponentLegend(numInputs, gType) {
    return nBitsGateTitle(getTextGateComponentLegend(gType), numInputs);
}

/**
 * `arrayText` is what an ARRAY COMPONENT's symbol draws in place of a number - see
 * SymbolT.Symbol.ArrayText. A join uses it for its channel, so a carry chain reads `Join[i+1]`
 * against `Join[i]` rather than showing what those expressions come to in copy 0. None everywhere
 * else, and on a join whose channel is a plain number, which draws that number as it always did.
 */
export function getComponentLegend(arrayText, componentType, rotation) {
    let matchResult, gateType, numInputs, n, n_1, n_2, x, x_1, x_2, x_3, x_4, n_3, tp, x_5, n_4, w, w_1, n_5, w_2;
    switch (componentType.tag) {
        case 10: {
            matchResult = 0;
            gateType = componentType.fields[0];
            numInputs = componentType.fields[1];
            break;
        }
        case 8: {
            matchResult = 1;
            break;
        }
        case 9: {
            matchResult = 2;
            break;
        }
        case 17: {
            matchResult = 3;
            n = componentType.fields[0];
            break;
        }
        case 18: {
            matchResult = 3;
            n = componentType.fields[0];
            break;
        }
        case 20: {
            matchResult = 3;
            n = componentType.fields[0];
            break;
        }
        case 19: {
            matchResult = 3;
            n = componentType.fields[0];
            break;
        }
        case 33: {
            matchResult = 4;
            n_1 = componentType.fields[0];
            break;
        }
        case 34: {
            matchResult = 4;
            n_1 = componentType.fields[0];
            break;
        }
        case 39: {
            matchResult = 5;
            break;
        }
        case 40: {
            matchResult = 6;
            break;
        }
        case 41: {
            matchResult = 7;
            break;
        }
        case 42: {
            matchResult = 8;
            break;
        }
        case 31: {
            matchResult = 9;
            break;
        }
        case 32: {
            matchResult = 10;
            break;
        }
        case 35: {
            matchResult = 11;
            n_2 = componentType.fields[0];
            break;
        }
        case 37: {
            matchResult = 11;
            n_2 = componentType.fields[0];
            break;
        }
        case 36: {
            matchResult = 11;
            n_2 = componentType.fields[0];
            break;
        }
        case 38: {
            matchResult = 11;
            n_2 = componentType.fields[0];
            break;
        }
        case 21: {
            if (componentType.fields[1] != null) {
                matchResult = 13;
                x_1 = componentType.fields[0];
            }
            else {
                matchResult = 12;
                x = componentType.fields[0];
            }
            break;
        }
        case 24: {
            matchResult = 14;
            x_2 = componentType.fields[0];
            break;
        }
        case 22: {
            matchResult = 15;
            x_3 = componentType.fields[0];
            break;
        }
        case 23: {
            matchResult = 16;
            x_4 = componentType.fields[0];
            break;
        }
        case 46: {
            matchResult = 17;
            n_3 = componentType.fields[0];
            tp = componentType.fields[2];
            break;
        }
        case 26: {
            matchResult = 18;
            x_5 = componentType.fields[0];
            break;
        }
        case 29: {
            matchResult = 19;
            break;
        }
        case 30: {
            matchResult = 20;
            break;
        }
        case 25: {
            if (componentType.fields[0] === 1) {
                matchResult = 21;
            }
            else {
                matchResult = 22;
                n_4 = componentType.fields[0];
            }
            break;
        }
        case 50: {
            matchResult = 23;
            w = componentType.fields[0];
            break;
        }
        case 51: {
            matchResult = 24;
            w_1 = componentType.fields[0];
            break;
        }
        case 52: {
            matchResult = 25;
            n_5 = componentType.fields[1];
            w_2 = componentType.fields[0];
            break;
        }
        case 53: {
            matchResult = 25;
            n_5 = componentType.fields[1];
            w_2 = componentType.fields[0];
            break;
        }
        default:
            matchResult = 26;
    }
    switch (matchResult) {
        case 0:
            return getGateComponentLegend(gateType);
        case 1:
            return "1";
        case 2:
            return "Decode";
        case 3:
            return busTitleAndBits("Adder", n);
        case 4:
            switch (rotation.tag) {
                case 1:
                case 3:
                    return busTitleAndBits("Reg", n_1);
                default:
                    return busTitleAndBits("Register", n_1);
            }
        case 5:
            return "Async.ROM";
        case 6:
            return "Sync.ROM";
        case 7:
            return "Sync.RAM";
        case 8:
            return "Async.RAM";
        case 9:
            return "DFF";
        case 10:
            return "DFFE";
        case 11:
            return busTitleAndBits("Counter", n_2);
        case 12:
            return nBitsGateTitle("Xor", x);
        case 13:
            return nBitsGateTitle("Multiply", x_1);
        case 14:
            return nBitsGateTitle("Or", x_2);
        case 15:
            return nBitsGateTitle("And", x_3);
        case 16:
            return nBitsGateTitle("Not", x_4);
        case 17:
            return busTitleAndBits((tp.tag === 1) ? "LSR" : ((tp.tag === 2) ? "ASR" : "LSL"), n_3);
        case 18:
            return x_5.Name.toLocaleUpperCase();
        case 19:
            return "Merge";
        case 20:
            return "Split";
        case 21:
            return "Spread";
        case 22:
            return `Spread.1→${n_4}`;
        case 23:
            return arrayLegend("BusOut", w);
        case 24:
            return arrayLegend("MuxOut", w_1);
        case 25:
            return arrayLegend(concat("Join[", defaultArg(arrayText, int32ToString(n_5)), "]"), w_2);
        default:
            return "";
    }
}

/**
 * By default all output ports are on the right, input ports on lefty, (of a normal orientation symbol).
 * A few symbols have ports on top or bottom as defined here.
 * Note that custom components can have ports positioned by user.
 */
export function movePortsToCorrectEdgeForComponentType(ct, portMaps) {
    switch (ct.tag) {
        case 11:
            return movePortToBottom(portMaps, 2);
        case 12:
            return movePortToBottom(portMaps, 4);
        case 13:
            return movePortToBottom(portMaps, 8);
        case 17:
        case 19:
            return movePortToBottom(new DrawModelType_SymbolT_PortMaps(add(Edge.Right, reverse(FSharpMap__get_Item(portMaps.Order, Edge.Right)), portMaps.Order), portMaps.Orientation), 0);
        case 32:
            return movePortToBottom(portMaps, 1);
        case 34:
            return movePortToBottom(portMaps, 1);
        case 14:
        case 15:
        case 16:
            return movePortToBottom(portMaps, 1);
        default:
            return portMaps;
    }
}

/**
 * Generates a new list of ports of specified type
 */
export function portLists(numOfPorts, hostID, portType) {
    if (numOfPorts < 1) {
        return empty();
    }
    else {
        return collect((x) => singleton(new Port(IdAllocator_newPortId(), x, portType, hostID)), toList(rangeDouble(0, 1, numOfPorts - 1)));
    }
}

export function customToLength(lst) {
    const labelList = map_1((arg) => (arg[0].length | 0), lst);
    if (isEmpty(labelList)) {
        return 0;
    }
    else {
        return max(labelList, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }) | 0;
    }
}

/**
 * get the max length (in pixels) of any of the Text strings in a list
 * Hack - for now assume text char width is constant
 */
export function customStringToLength(lst) {
    if (isEmpty(lst)) {
        return 0;
    }
    else {
        return max(map_1((portLab) => getTextWidthInPixels(Constants_componentPortStyle, portLab), lst), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
    }
}

export function addPortToMaps(edge, portMaps, portId) {
    return new DrawModelType_SymbolT_PortMaps(add(edge, append(FSharpMap__get_Item(portMaps.Order, edge), singleton(portId)), portMaps.Order), add(portId, edge, portMaps.Orientation));
}

export function deletePortFromMaps(port, portMaps) {
    return new DrawModelType_SymbolT_PortMaps(map((edge, pL) => filter((y) => !equals(port, y), pL), portMaps.Order), remove(port, portMaps.Orientation));
}

/**
 * work out the initial (default) port placing for a componenent.
 * also used for legacy circuits loaded without port layoiut info.
 */
export function initPortOrientation(comp) {
    return movePortsToCorrectEdgeForComponentType(comp.Type, fold((maps_1, port_1) => addPortToMaps(Edge.Right, maps_1, port_1.Id), fold((maps, port) => addPortToMaps(Edge.Left, maps, port.Id), new DrawModelType_SymbolT_PortMaps(fold((currMap, edge) => add(edge, empty(), currMap), empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), ofArray([Edge.Left, Edge.Right, Edge.Top, Edge.Bottom])), empty_1({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    })), comp.InputPorts), reverse(comp.OutputPorts)));
}

/**
 * obtain map from port IDs to port names for Custom Component.
 * for other components types this returns empty map
 */
export function getCustomPortIdMap(comp) {
    const matchValue = comp.Type;
    if (matchValue.tag === 26) {
        const customType = matchValue.fields[0];
        const inputPortIdLabels = zip(comp.InputPorts, customType.InputLabels);
        const outputPortIdLabels = zip(comp.OutputPorts, customType.OutputLabels);
        return fold((currMap_1, tupledArg_1) => add(tupledArg_1[0].Id, tupledArg_1[1][0], currMap_1), fold((currMap, tupledArg) => add(tupledArg[0].Id, tupledArg[1][0], currMap), empty_1({
            Compare: (x, y) => (compare(x, y) | 0),
        }), inputPortIdLabels), outputPortIdLabels);
    }
    else {
        return empty_1({
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        });
    }
}

/**
 * Needed because the I/Os of a custom component can be changed on anotehr sheet.
 * When the component is reloaded its port maps will be inconsistent.
 * This function keeps existing layout, and adds new I/Os or deletes old ones.
 */
export function makeMapsConsistent(portIdMap, sym) {
    const newPortIds = ofSeq(keys(portIdMap), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const currentPortIds = ofSeq(keys(sym.PortMaps.Orientation), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    const addedPortIds = FSharpSet_op_Subtraction(newPortIds, currentPortIds);
    const deletedPortIds = FSharpSet_op_Subtraction(currentPortIds, newPortIds);
    const tupledArg = [fold_1((maps_1, port) => addPortToMaps(exists((p) => equals(p.Id, port), sym.Component.InputPorts) ? Edge.Left : Edge.Right, maps_1, port), sym.PortMaps, addedPortIds), deletedPortIds];
    return fold_1((maps_3, port_1) => deletePortFromMaps(port_1, maps_3), tupledArg[0], tupledArg[1]);
}

/**
 * adjust symbol (and component) dimensions based on current ports and labels of a custom component.
 * leaves other symbols unchanged
 */
export function autoScaleHAndW(sym) {
    let matchValue, portIdMap, portMaps, portLabels, h, getHorizontalSpace, leftSpace, rightSpace, topLength, bottomLength, labelLength, scaledW, bind$0040, comp;
    return calcLabelBoundingBox((matchValue = sym.Component.Type, (matchValue.tag === 26) ? ((portIdMap = getCustomPortIdMap(sym.Component), (portMaps = makeMapsConsistent(portIdMap, sym), (portLabels = fold_2((currMap, edge, idList) => add(edge, map_1((id) => FSharpMap__get_Item(portIdMap, id), idList), currMap), empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), portMaps.Order), (h = (30 + (Constants_customPortSpacing * max_1(length(FSharpMap__get_Item(portLabels, Edge.Left)), length(FSharpMap__get_Item(portLabels, Edge.Right))))), (getHorizontalSpace = ((side) => {
        const labs = FSharpMap__get_Item(portLabels, side);
        if ((length(labs) % 2) === 0) {
            return 0;
        }
        else {
            return customStringToLength(singleton(item(~~(length(labs) / 2), labs)));
        }
    }), (leftSpace = getHorizontalSpace(Edge.Left), (rightSpace = getHorizontalSpace(Edge.Right), (topLength = customStringToLength(FSharpMap__get_Item(portLabels, Edge.Top)), (bottomLength = customStringToLength(FSharpMap__get_Item(portLabels, Edge.Bottom)), (labelLength = ((Constants_customLegendFontSizeInPixels / Constants_portFontSizeInPixels) * customStringToLength(singleton(matchValue.fields[0].Name))), (scaledW = max_1(1.1 * max(ofArray([((2 * max_1(leftSpace, rightSpace)) + (labelLength * 1.333)) + 10, (length(FSharpMap__get_Item(portLabels, Edge.Top)) + 1) * topLength, (length(FSharpMap__get_Item(portLabels, Edge.Bottom)) + 1) * bottomLength]), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), 30 * 4), new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, (bind$0040 = sym.Component, new Component_2(bind$0040.Id, bind$0040.Type, bind$0040.Label, bind$0040.InputPorts, bind$0040.OutputPorts, sym.Pos.X, sym.Pos.Y, max_1(h, 30 * 2), scaledW, bind$0040.SymbolInfo, bind$0040.SlotInfo)), sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, portMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText))))))))))))) : ((comp = sym.Component, new DrawModelType_SymbolT_Symbol(sym.Pos, sym.CentrePos, sym.OffsetFromBBCentre, sym.InWidth0, sym.InWidth1, sym.InWidths, sym.LabelBoundingBox, sym.LabelHasDefaultPos, sym.LabelRotation, sym.Appearance, sym.Id, new Component_2(comp.Id, comp.Type, comp.Label, comp.InputPorts, comp.OutputPorts, sym.Pos.X, sym.Pos.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo), sym.Annotation, sym.Moving, sym.IsClocked, sym.STransform, sym.ReversedInputPorts, sym.PortMaps, sym.HScale, sym.VScale, sym.MovingPort, sym.MovingPortTarget, sym.ArrayText)))));
}

/**
 * return (num inputs, num outputs, height, width)
 * The port counts and size of one of an ARRAY COMPONENT's IO symbols, sized to the legend it will
 * actually draw.
 * 
 * Its own function because the legend can hold a channel EXPRESSION - `Join[i+10]` where the
 * component type alone says `Join[1]` - and only a symbol knows that text. getComponentProperties
 * sizes from the type and so passes None; SymbolReplaceHelpers.resizedForLegend has the symbol and
 * passes what it draws, which is what keeps the text inside the shape.
 */
export function arrayIOProperties(arrayText, compType) {
    const gS = 30;
    const widthFor = (str_1) => ((getTextWidthInPixels(arrayLegendStyle, str_1) + 14) / 0.8);
    const w = max(ofArray([3 * gS, widthFor(widestExpectedJoinLegend), widthFor(getComponentLegend(arrayText, compType, Rotation.Degree0))]), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    if (compType.tag === 53) {
        return [0, 1, gS, w];
    }
    else {
        return [1, 0, gS, w];
    }
}

export function getComponentProperties(compType, label) {
    const gS = 30;
    let matchResult, a_2, b, a_13, n_5;
    switch (compType.tag) {
        case 48: {
            matchResult = 1;
            break;
        }
        case 10: {
            matchResult = 2;
            break;
        }
        case 29: {
            matchResult = 3;
            break;
        }
        case 30: {
            matchResult = 4;
            break;
        }
        case 8: {
            matchResult = 5;
            break;
        }
        case 0: {
            matchResult = 6;
            break;
        }
        case 1: {
            matchResult = 7;
            break;
        }
        case 50:
        case 51:
        case 52:
        case 53: {
            matchResult = 8;
            break;
        }
        case 54: {
            matchResult = 9;
            break;
        }
        case 55: {
            matchResult = 10;
            break;
        }
        case 2: {
            matchResult = 11;
            break;
        }
        case 3: {
            matchResult = 12;
            break;
        }
        case 4: {
            matchResult = 13;
            break;
        }
        case 9: {
            matchResult = 14;
            break;
        }
        case 27: {
            matchResult = 16;
            break;
        }
        case 28: {
            matchResult = 17;
            break;
        }
        case 11: {
            matchResult = 18;
            break;
        }
        case 12: {
            matchResult = 19;
            break;
        }
        case 13: {
            matchResult = 20;
            break;
        }
        case 14: {
            matchResult = 21;
            break;
        }
        case 15: {
            matchResult = 22;
            break;
        }
        case 16: {
            matchResult = 23;
            break;
        }
        case 6: {
            matchResult = 24;
            break;
        }
        case 47:
        case 5: {
            matchResult = 25;
            break;
        }
        case 31: {
            matchResult = 26;
            break;
        }
        case 32: {
            matchResult = 27;
            break;
        }
        case 33: {
            matchResult = 28;
            break;
        }
        case 34: {
            matchResult = 29;
            break;
        }
        case 35: {
            matchResult = 30;
            break;
        }
        case 37: {
            matchResult = 31;
            break;
        }
        case 36: {
            matchResult = 32;
            break;
        }
        case 38: {
            matchResult = 33;
            break;
        }
        case 39: {
            matchResult = 34;
            break;
        }
        case 40: {
            matchResult = 35;
            break;
        }
        case 23: {
            matchResult = 38;
            break;
        }
        case 25: {
            matchResult = 39;
            break;
        }
        case 17: {
            matchResult = 40;
            break;
        }
        case 18: {
            matchResult = 41;
            break;
        }
        case 19: {
            matchResult = 42;
            break;
        }
        case 20: {
            matchResult = 43;
            break;
        }
        case 46: {
            matchResult = 44;
            break;
        }
        case 26: {
            matchResult = 45;
            break;
        }
        case 7: {
            matchResult = 15;
            a_2 = compType.fields[0];
            b = compType.fields[1];
            break;
        }
        case 49: {
            matchResult = 15;
            a_2 = compType.fields[0];
            b = compType.fields[1];
            break;
        }
        case 41: {
            matchResult = 36;
            a_13 = compType.fields[0];
            break;
        }
        case 42: {
            matchResult = 36;
            a_13 = compType.fields[0];
            break;
        }
        case 21: {
            matchResult = 37;
            n_5 = compType.fields[0];
            break;
        }
        case 24: {
            matchResult = 37;
            n_5 = compType.fields[0];
            break;
        }
        case 22: {
            matchResult = 37;
            n_5 = compType.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return toFail(printf("What? Legacy RAM component types should never occur"));
        case 1:
            return toFail(printf("Legacy Input component types should never occur"));
        case 2: {
            const n = compType.fields[1] | 0;
            return [n, 1, ((1.5 * gS) * n) / 2, 1.5 * gS];
        }
        case 3: {
            const n_1 = compType.fields[0] | 0;
            return [n_1, 1, ((2 * gS) * ((n_1 < 3) ? 3 : n_1)) / 2, 3 * gS];
        }
        case 4: {
            const n_2 = compType.fields[0] | 0;
            return [1, n_2, ((2 * gS) * ((n_2 < 3) ? 3 : n_2)) / 2, 3 * gS];
        }
        case 5:
            return [1, 1, 1 * gS, 1 * gS];
        case 6:
            return [0, 1, gS, 2 * gS];
        case 7:
            return [1, 0, gS, 2 * gS];
        case 8:
            return arrayIOProperties(undefined, compType);
        case 9: {
            const n_3 = compType.fields[0] | 0;
            return [n_3, 1, ((2 * gS) * max_1(n_3, 3)) / 2, 3 * gS];
        }
        case 10: {
            const n_4 = compType.fields[0] | 0;
            return [n_4 + 1, 1, ((2 * gS) * max_1(n_4, 3)) / 2, 2 * gS];
        }
        case 11:
            return [1, 0, gS, gS];
        case 12:
            return [1, 1, gS / 2, gS];
        case 13:
            return [1, 0, gS, gS];
        case 14:
            return [2, 4, 8 * gS, 3 * gS];
        case 15:
            return [0, 1, gS, 2 * gS];
        case 16:
            return [2, 1, 2 * gS, 2 * gS];
        case 17:
            return [1, 2, 2 * gS, 2 * gS];
        case 18:
            return [3, 1, 3 * gS, 2 * gS];
        case 19:
            return [5, 1, 8 * gS, 2 * gS];
        case 20:
            return [9, 1, 16 * gS, 2 * gS];
        case 21:
            return [2, 2, 3 * gS, 2 * gS];
        case 22:
            return [2, 4, 8 * gS, 2 * gS];
        case 23:
            return [2, 8, 16 * gS, 2 * gS];
        case 24:
            return [1, 1, gS / 2, 2 * gS];
        case 25:
            return [1, 1, gS, 2 * gS];
        case 26:
            return [1, 1, 2.5 * gS, 2.5 * gS];
        case 27:
            return [2, 1, 2.5 * gS, 2.5 * gS];
        case 28:
            return [1, 1, 2 * gS, 4 * gS];
        case 29:
            return [2, 1, 2 * gS, 4 * gS];
        case 30:
            return [3, 1, 4 * gS, 5 * gS];
        case 31:
            return [2, 1, 3 * gS, 5 * gS];
        case 32:
            return [1, 1, 2 * gS, 5 * gS];
        case 33:
            return [0, 1, 2 * gS, 3.5 * gS];
        case 34:
            return [1, 1, 4 * gS, 5 * gS];
        case 35:
            return [1, 1, 4 * gS, 5 * gS];
        case 36:
            return [3, 1, 4 * gS, 5 * gS];
        case 37:
            return [2, 1, 4 * gS, 4 * gS];
        case 38:
            return [1, 1, 3 * gS, 4 * gS];
        case 39:
            return [1, 1, 2 * gS, 4 * gS];
        case 40:
            return [3, 2, 3 * gS, 4 * gS];
        case 41:
            return [2, 2, 3 * gS, 4 * gS];
        case 42:
            return [3, 1, 3 * gS, 4 * gS];
        case 43:
            return [2, 1, 3 * gS, 4 * gS];
        case 44:
            return [2, 1, 3 * gS, 4 * gS];
        default: {
            const cct = compType.fields[0];
            return [length(cct.InputLabels), length(cct.OutputLabels), 0, 0];
        }
    }
}

/**
 * make a completely new component
 */
export function makeComponent(pos, compType, id, label) {
    let PortOrder;
    const defaultSTransform = new STransform(Rotation.Degree0, false);
    const tupledArg = getComponentProperties(compType, label);
    const h = tupledArg[2];
    const w = tupledArg[3];
    return new Component_2(id, compType, label, portLists(tupledArg[0], id, PortType.Input), portLists(tupledArg[1], id, PortType.Output), pos.X - (w / 2), pos.Y - (h / 2), h, w, (PortOrder = empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), new SymbolInfo(undefined, undefined, defaultSTransform, undefined, empty_1({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }), PortOrder, undefined, undefined)), undefined);
}

export const clockedSheetsOf = memoizeByIdentity(clockedSheets);

export function createNewSymbol(ldcs, pos, comptype, label, theme) {
    let sym_1, topLeft, bind$0040;
    const id = IdAllocator_newComponentId();
    const comp = makeComponent(pos, comptype, id, label);
    const transform = new STransform(Rotation.Degree0, false);
    const clocked = isClockedGiven(clockedSheetsOf(ldcs), comp);
    return calcLabelBoundingBox((sym_1 = autoScaleHAndW(new DrawModelType_SymbolT_Symbol(new XYPos(pos.X - (comp.W / 2), pos.Y - (comp.H / 2)), new XYPos(0, 0), new XYPos(0, 0), undefined, undefined, undefined, new BoundingBox(pos, 0, 0), true, undefined, new DrawModelType_SymbolT_AppearanceT(DrawModelType_SymbolT_ShowPorts.ShowNone, DrawModelType_SymbolT_ShowCorners.DontShow, false, getSymbolColour(comptype, clocked, theme), 1), id, comp, undefined, false, clocked, transform, false, initPortOrientation(comp), undefined, undefined, undefined, undefined, undefined)), (topLeft = (new XYPos(pos.X - (sym_1.Component.W / 2), pos.Y - (sym_1.Component.H / 2))), new DrawModelType_SymbolT_Symbol(topLeft, sym_1.CentrePos, sym_1.OffsetFromBBCentre, sym_1.InWidth0, sym_1.InWidth1, sym_1.InWidths, sym_1.LabelBoundingBox, sym_1.LabelHasDefaultPos, sym_1.LabelRotation, sym_1.Appearance, sym_1.Id, (bind$0040 = sym_1.Component, new Component_2(bind$0040.Id, bind$0040.Type, bind$0040.Label, bind$0040.InputPorts, bind$0040.OutputPorts, topLeft.X, topLeft.Y, bind$0040.H, bind$0040.W, bind$0040.SymbolInfo, bind$0040.SlotInfo)), sym_1.Annotation, sym_1.Moving, sym_1.IsClocked, sym_1.STransform, sym_1.ReversedInputPorts, sym_1.PortMaps, sym_1.HScale, sym_1.VScale, sym_1.MovingPort, sym_1.MovingPortTarget, sym_1.ArrayText))));
}

export function addToPortModel(model, sym) {
    const addOnePort = (currentPorts, port) => add(port.Id, port, currentPorts);
    return fold(addOnePort, fold(addOnePort, model.Ports, sym.Component.InputPorts), sym.Component.OutputPorts);
}

/**
 * Returns true if an edge has the select port of a mux
 */
export function isMuxSel(sym, side) {
    const matchValue = sym.Component.Type;
    switch (matchValue.tag) {
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16: {
            const matchValue_1 = sym.STransform.Rotation;
            let matchResult;
            switch (matchValue_1.tag) {
                case 1: {
                    switch (side.tag) {
                        case 2:
                        case 3: {
                            matchResult = 0;
                            break;
                        }
                        default:
                            matchResult = 1;
                    }
                    break;
                }
                case 2: {
                    switch (side.tag) {
                        case 1:
                        case 0: {
                            matchResult = 0;
                            break;
                        }
                        default:
                            matchResult = 1;
                    }
                    break;
                }
                case 3: {
                    switch (side.tag) {
                        case 2:
                        case 3: {
                            matchResult = 0;
                            break;
                        }
                        default:
                            matchResult = 1;
                    }
                    break;
                }
                default:
                    switch (side.tag) {
                        case 1:
                        case 0: {
                            matchResult = 0;
                            break;
                        }
                        default:
                            matchResult = 1;
                    }
            }
            switch (matchResult) {
                case 0:
                    return true;
                default:
                    return false;
            }
        }
        default:
            return false;
    }
}

/**
 * Based on a symbol and an edge, if the port is a mux select, return an extra offset required for the port (because of the weird shape of the mux)
 */
export function getMuxSelOffset(sym, side) {
    const sideOffset = (offset) => {
        switch (side.tag) {
            case 1:
                return new XYPos(0, -offset);
            case 2:
                return new XYPos(offset, 0);
            case 3:
                return new XYPos(-offset, 0);
            default:
                return new XYPos(0, offset);
        }
    };
    const compType = sym.Component.Type;
    if (isMuxSel(sym, side)) {
        switch (compType.tag) {
            case 11:
            case 14:
                return sideOffset(9);
            case 12:
            case 15:
                return sideOffset(9.5);
            case 13:
            case 16:
                return sideOffset(9.5);
            default:
                return new XYPos(0, 0);
        }
    }
    else {
        return new XYPos(0, 0);
    }
}

/**
 * Given a symbol and a port, it returns the offset of the port from the top left corner of the symbol
 */
export function getPortPos(sym, port) {
    const side = FSharpMap__get_Item(sym.PortMaps.Orientation, port.Id);
    const ports = FSharpMap__get_Item(sym.PortMaps.Order, side);
    const numberOnSide = length(ports) | 0;
    const index = findIndex((p) => equals(p, port.Id), ports) | 0;
    let index$0027;
    const matchValue = sym.ReversedInputPorts;
    let matchResult;
    if (matchValue != null) {
        if (matchValue) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            index$0027 = ((numberOnSide - 1) - index);
            break;
        }
        default:
            index$0027 = index;
    }
    let gap;
    const ct = sym.Component.Type;
    let matchResult_1;
    switch (ct.tag) {
        case 27:
        case 28: {
            matchResult_1 = 0;
            break;
        }
        case 11: {
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 1;
            }
            break;
        }
        case 29: {
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 1;
            }
            break;
        }
        case 30: {
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 1;
            }
            break;
        }
        default:
            if ($007CIsBinaryGate$007CNotBinaryGate$007C(ct).tag === 0) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 2;
            }
    }
    switch (matchResult_1) {
        case 0: {
            gap = 0.25;
            break;
        }
        case 1: {
            gap = Constants_gatePortPosEdgeGap;
            break;
        }
        default:
            gap = Constants_portPosEdgeGap;
    }
    const topBottomGap = gap + 0.3;
    let baseOffset$0027;
    let left;
    const side_1 = side;
    let patternInput;
    const sym_3 = sym;
    const comp = sym_3.Component;
    const matchValue_1 = defaultArg(sym_3.HScale, 1);
    const vS = defaultArg(sym_3.VScale, 1);
    const hS = matchValue_1;
    const matchValue_2 = sym_3.STransform.Rotation;
    switch (matchValue_2.tag) {
        case 1:
        case 3: {
            patternInput = [comp.W * hS, comp.H * vS];
            break;
        }
        default:
            patternInput = [comp.H * vS, comp.W * hS];
    }
    left = ((side_1.tag === 2) ? (new XYPos(0, 0)) : ((side_1.tag === 0) ? (new XYPos(0, 0)) : ((side_1.tag === 1) ? (new XYPos(0, patternInput[0])) : (new XYPos(patternInput[1], 0)))));
    const right = getMuxSelOffset(sym, side);
    baseOffset$0027 = (new XYPos(left.X + right.X, left.Y + right.Y));
    const portDimension = length(ports) - 1;
    let patternInput_3;
    const sym_4 = sym;
    const comp_1 = sym_4.Component;
    const matchValue_3 = defaultArg(sym_4.HScale, 1);
    const vS_1 = defaultArg(sym_4.VScale, 1);
    const hS_1 = matchValue_3;
    const matchValue_2_1 = sym_4.STransform.Rotation;
    switch (matchValue_2_1.tag) {
        case 1:
        case 3: {
            patternInput_3 = [comp_1.W * hS_1, comp_1.H * vS_1];
            break;
        }
        default:
            patternInput_3 = [comp_1.H * vS_1, comp_1.W * hS_1];
    }
    const w_1 = patternInput_3[1];
    const h_1 = patternInput_3[0];
    switch (side.tag) {
        case 3: {
            const left_2 = baseOffset$0027;
            const right_2 = new XYPos(0, (h_1 * ((portDimension - index$0027) + gap)) / (portDimension + (2 * gap)));
            return new XYPos(left_2.X + right_2.X, left_2.Y + right_2.Y);
        }
        case 1: {
            const left_3 = baseOffset$0027;
            const right_3 = new XYPos((w_1 * (index$0027 + topBottomGap)) / (portDimension + (2 * topBottomGap)), 0);
            return new XYPos(left_3.X + right_3.X, left_3.Y + right_3.Y);
        }
        case 0: {
            const left_4 = baseOffset$0027;
            const right_4 = new XYPos((w_1 * ((portDimension - index$0027) + topBottomGap)) / (portDimension + (2 * topBottomGap)), 0);
            return new XYPos(left_4.X + right_4.X, left_4.Y + right_4.Y);
        }
        default: {
            const left_1 = baseOffset$0027;
            const right_1 = new XYPos(0, (h_1 * (index$0027 + gap)) / (portDimension + (2 * gap)));
            return new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y);
        }
    }
}

/**
 * Returns the location of a given portId, with good efficiency
 */
export function getPortLocation(defPos, model, portId) {
    const portOpt = tryFind(portId, model.Ports);
    let symOpt;
    let option_3;
    const option_1 = portOpt;
    option_3 = ((option_1 != null) ? option_1.HostId : undefined);
    symOpt = ((option_3 != null) ? tryFind(option_3, model.Symbols) : undefined);
    let matchResult, port_1, sym, pos;
    if (symOpt != null) {
        if (portOpt != null) {
            matchResult = 0;
            port_1 = portOpt;
            sym = symOpt;
        }
        else if (defPos != null) {
            matchResult = 1;
            pos = defPos;
        }
        else {
            matchResult = 2;
        }
    }
    else if (defPos != null) {
        matchResult = 1;
        pos = defPos;
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            const left = getPortPos(sym, port_1);
            const right = sym.Pos;
            return new XYPos(left.X + right.X, left.Y + right.Y);
        }
        case 1: {
            warn(`cannot find port or symbol: port='${portOpt}', symbol='${symOpt}'`);
            return pos;
        }
        default:
            return toFail(`Can't find port or symbol: Port='${portOpt}', Symbol='${symOpt}`);
    }
}

/**
 * Returns the input port positions of the specified symbols in model
 */
export function getInputPortsLocationMap(model, symbols) {
    return ofList(collect((sym) => map_1((port) => {
        let left, right;
        return [port.Id, (left = getPortPos(sym, port), (right = sym.Pos, new XYPos(left.X + right.X, left.Y + right.Y)))];
    }, sym.Component.InputPorts), symbols), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

/**
 * Returns the output port positions of the specified symbols in model
 */
export function getOutputPortsLocationMap(model, symbols) {
    return ofList(collect((sym) => map_1((port) => {
        let left, right;
        return [port.Id, (left = getPortPos(sym, port), (right = sym.Pos, new XYPos(left.X + right.X, left.Y + right.Y)))];
    }, sym.Component.OutputPorts), symbols), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

/**
 * Returns all the port locations of the given components
 */
export function getPortLocations(model, symbolIds) {
    const symbols = map_1((tuple) => tuple[1], toList_1(filter_1((symbolId, _arg) => contains(symbolId, symbolIds, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), model.Symbols)));
    return [getInputPortsLocationMap(model, symbols), getOutputPortsLocationMap(model, symbols)];
}

